import { gql } from 'apollo-angular';
import { Invoice } from '../../shared/entities/payment/payment';
import { PaymentMethod } from '../../shared/entities/paymentMethod/tenantLicenceRequest';
import { Tenant } from '../../shared/entities/tenant/tenant';
import { TenantLicenceRequest } from '../../shared/entities/tenantLicenceRequest/tenantLicenceRequest';

export const INVOICES_QUERY = gql`
query getInvoices(
  $tenantId: String
)
{
  invoices: getInvoices(
    tenantId: $tenantId
  )
  {
    number
    date
    amount
    currency
    downloadLink
    state
  }
  paymentMethod: getPaymentMethod(tenantId: $tenantId){
    type
    details
    updateLink
  }
  tenant: getTenantByTenantId(
    tenantId: $tenantId
  )
  {
    id
    hasOpenLicenceRequests
    invoiceEmail
    invoiceAddress {
      id
      name
      addressLine0
      addressLine1
      postalCode
      city
      country
      vatNumber
      vatType
    }
  }
}
`;

export interface InvoicesQueryResponse {
  loading: boolean;
  invoices: Invoice[];
  tenantLicenceRequests: TenantLicenceRequest[];
  tenant: Tenant;
  paymentMethod: PaymentMethod;
}

